import script from "./SharePoints.vue?vue&type=script&setup=true&lang=js"
export * from "./SharePoints.vue?vue&type=script&setup=true&lang=js"

import "./SharePoints.vue?vue&type=style&index=0&id=6f388890&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f388890"]])

export default __exports__